import type { RollupPeriodType } from "../../../types";

export interface PeriodOption {
  key: string;
  label: string;
}

const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

/**
 * Recent selectable periods for a given type, most recent first. Generated
 * client-side from today's date; keys/labels mirror the backend's periodRange.
 */
export function recentPeriods(type: RollupPeriodType, now: Date = new Date()): PeriodOption[] {
  const y = now.getUTCFullYear();
  const m = now.getUTCMonth(); // 0-11

  if (type === "month") {
    return Array.from({ length: 12 }, (_, i) => {
      const d = new Date(Date.UTC(y, m - i, 1));
      const yy = d.getUTCFullYear();
      const mm = d.getUTCMonth();
      return { key: `${yy}-${String(mm + 1).padStart(2, "0")}`, label: `${MONTH_NAMES[mm]} ${yy}` };
    });
  }

  if (type === "quarter") {
    const currentQ = Math.floor(m / 3); // 0-3
    return Array.from({ length: 8 }, (_, i) => {
      const totalQ = y * 4 + currentQ - i;
      const yy = Math.floor(totalQ / 4);
      const q = (totalQ % 4) + 1;
      return { key: `${yy}-Q${q}`, label: `Q${q} ${yy}` };
    });
  }

  return Array.from({ length: 4 }, (_, i) => ({ key: `${y - i}`, label: `${y - i}` }));
}
